import { render, staticRenderFns } from "./PrintAmendmentsExport.vue?vue&type=template&id=1fcd29e0&"
import script from "./PrintAmendmentsExport.vue?vue&type=script&lang=js&"
export * from "./PrintAmendmentsExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports